<template>
    <div>
      <div>
        <apexchart
          type="bar"
          width="100%"
          height="460px"
          :options="chartOptions"
          :series="seriesEms"
        />
      </div>
    </div>
  </template>
  
  <script>
  export default {
    name: "CIIIndextoBaseline",
    props: ["loaded", "dataset"],
    components: {},
  
    data: function () {
      return {
        fuelConsumptionUnit: "",
  
        categoriesEMS: [],
  
        seriesEms: [
          {
            data: [],
          },
          {
            data: [],
          },
          {
            data: [],
          },
        ],
      };
    },
    computed: {
      chartOptions: function () {
        var self = this;
        return {
          chart: {
            animations: {
              enabled: true,
              easing: "easeinout",
              speed: 800,
              animateGradually: {
                enabled: true,
                delay: 150,
              },
              dynamicAnimation: {
                enabled: true,
                speed: 350,
              },
            },
            stacked: false,
            foreColor: "#9c9c9c",
            zoom: {
              type: "xy",
              enabled: true,
            },
            toolbar: {
              show: true,
              tools: {
                download: false,
                selection: false,
                zoom: true,
                zoomin: true,
                zoomout: true,
                pan: false,
                reset: false,
              },
            },
          },
          plotOptions: {
            bar: {
              horizontal: true,
              barHeight: "70%",
              dataLabels: {
                position: "bottom",
              },
            },
          },
          grid: {
            borderColor: "#53565d",
          },
          legend: {
            show: true,
            showForSingleSeries: true,
          },
          dataLabels: {
            textAnchor: "start",
            offsetX: -10,
            formatter: function (val, opts) {
              if (val == 0) {
                return "";
              } else {
                return val;
              }
            },
            enabled: true,
            style: {
              fontSize: "12px",
              colors: ["#ffffff"],
            },
            dropShadow: {
              enabled: true,
              top: 2,
              left: 2,
              blur: 1,
              color: "#000",
              opacity: 0.85,
            },
          },
          stroke: {
            type: "gradient",
            gradient: {
              shadeIntensity: 0.5,
              opacityFrom: 0.9,
              opacityTo: 1,
              stops: [0, 90, 100],
            },
            width: 0,
            color: "#24292e",
          },
          colors: ["#ffff00", "#0d833c", "#0474be"],
          fill: {
            type: "gradient",
            gradient: {
              shadeIntensity: 0.5,
              opacityFrom: 0.9,
              opacityTo: 1,
              stops: [0, 90, 100],
            },
          },
          xaxis: {
            categories: self.categoriesEMS,
          },
          yaxis: {
            tickAmount: 7,
            axisBorder: {
              show: true,
            },
            labels: {
              style: {
                color: "#9c9c9c",
              },
            },
          },
          tooltip: {
            enabled: true,
            theme: "dark",
            x: {
              formatter: function (val) {
                return "CII Index:";
              },
            },
            y: {
              formatter: function (val) {
                return val;
              },
            },
          },
        };
      },
      chartDates() {
        return this.$store.getters.chartDates;
      },
    },
    watch: {
      dataset: function () {
        this.updateChart();
      },
  
      loaded: function () {
        this.updateChart();
      },
    },
    methods: {
      updateChart: function () {
        this.seriesEms = this.dataset.series;
        this.categoriesEMS = this.dataset.categories;
      },
  
      goHome() {
        this.status = "normal";
        this.updateChart();
      },
    },
  };
  </script>
  
  <!-- Add "scoped" attribute to limit CSS to this component only -->
  <style>
  </style>